import {Component} from "@angular/core";
import {PopoverComponent} from "../../../shared/components/popover/popover.component";

@Component({
  selector: "pcg-ng-discount-message-popover",
  template: require('./discount-message-popover.component.html')
})
export class DiscountMessagePopoverComponent extends PopoverComponent {
    public popoverTemplate: string = "<div class='popover pcg-quick-shop__discount-message' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body'></div></div>";
}
